// @flow

import { combineReducers } from "redux";

import blogs from "./blogs/reducer";
import messages from "./messages/reducer";
import photos from "./photos/reducer";
import context from "./context/reducer";
import map from "./map/reducer";

export default combineReducers({
    context,
    blogs,
    messages,
    photos,
    map
});



// WEBPACK FOOTER //
// ./src/state/reducer.js